module.exports = __webpack_public_path__ + "static/media/adjust.b220649d.svg";